import {
  isMaintenanceAlertAcknowledged,
  isMaintenanceAlertMode,
} from 'components/VideoPlayer/Transcription/MediaUtilities';
import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Roles } from '../../utils/enum';
import { Routes } from '../../utils/routes';
import { customToast } from '../../utils/toast.util';
import { getDomainWithoutSubdomain, getToken, getUserRole } from '../../utils/utils';

const AdminDeniedRedirect = () => {
  useEffect(() => {
    customToast.error('Admin Portal is only available to administrators.');
  }, []);

  return <Redirect to={Routes.LIBRARY} />;
};

export const PrivateRoute = ({
  component: Component,
  path,
  requireAdmin,
  ...rest
}: any) => (
  <Route
    {...rest}
    render={(props) => {
      if (!getToken()) {
        window.location.replace(
          `${
            window.location.protocol
          }//${getDomainWithoutSubdomain()}/signin?next=${encodeURIComponent(
            window.location.href,
          )}`,
        );
      }
      if (
        isMaintenanceAlertMode() &&
        !isMaintenanceAlertAcknowledged() &&
        path !== Routes.MAINTENANCE
      ) {
        return <Redirect to={Routes.MAINTENANCE} />;
      }
      if (requireAdmin && getUserRole() !== Roles.ADMIN) {
        return <AdminDeniedRedirect />;
      }
      return <Component {...props} />;
    }}
  />
);
